import axios from 'axios';
import engineeringStore from './model';

export function getWeekList() {
    axios.get('/zhgd/index/engineerManagement?pageNo=1&pageSize=10000')
        .then(
            data => {
                engineeringStore.setWeekList(data.result);
            }
        )
        .catch(e => console.log(e));
}